import React, { useState } from "react"
import { NETWORK_ID_TIER_MAPPING } from "../../utils/networkIdMapping"
import { tierForModalProps, TierInfoModal } from "./TierInfoModal"
import { FormattedMessage } from "react-intl"
import { Benefit } from "#/lib/carrot-api/types/Benefit"
import { Box, Chip, ChipProps, InfoIcon, Link } from "@carrotfertility/carotene-core"

function getChipStyleByNetworkTier(networkId: number): Partial<ChipProps> {
  switch (networkId) {
    case 5:
      return {
        color: "default"
      }
    case 6:
      return {
        color: "info"
      }
  }
  return {}
}

export function TieredNetworkChip({ networkIds, benefit }: { networkIds: number[]; benefit: Benefit }): JSX.Element {
  const [open, setOpen] = useState(false)
  const [tierForModal, setTierForModal] = useState<tierForModalProps>(null)
  const providerTierTags = React.useMemo(
    () =>
      networkIds
        .map((networkId, i) => {
          const providerTier = NETWORK_ID_TIER_MAPPING[networkId as keyof typeof NETWORK_ID_TIER_MAPPING]
          if (!providerTier) {
            return null
          }
          return (
            <Link
              component="button"
              key={i}
              onClick={() => {
                setOpen(true)
                setTierForModal(providerTier)
              }}
            >
              <Chip
                {...getChipStyleByNetworkTier(networkId)}
                size="small"
                key={i}
                label={
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <FormattedMessage {...providerTier.tierDisplayName} />
                    &nbsp;
                    <InfoIcon color="inherit" fontSize="inherit" />
                  </Box>
                }
              />
            </Link>
          )
        })
        .filter(Boolean),
    [networkIds]
  )

  return (
    <>
      {providerTierTags}
      <TierInfoModal open={open} onClose={() => setOpen(false)} tierForModal={tierForModal} benefit={benefit} />
    </>
  )
}
